// src/components/ui/ValueIcon.jsx
import React from 'react';

/**
 * A centralized component for rendering value icons
 * Accepts an icon name and returns the appropriate SVG icon
 * 
 * @param {Object} props - Component props
 * @param {string} props.icon - Icon name (e.g. "lightning", "shield", etc.)
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.size - Size of the icon (defaults to "medium")
 */
const ValueIcon = ({ icon, className = "", size = "medium" }) => {
  // Calculate size classes based on the size prop
  const sizeClasses = {
    small: "h-6 w-6",
    medium: "h-10 w-10",
    large: "h-16 w-16"
  };
  
  const sizeClass = sizeClasses[size] || sizeClasses.medium;
  const combinedClasses = `${sizeClass} ${className}`;
  
  // Return the appropriate icon based on the icon name
  switch (icon) {
    case 'lightning':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
        </svg>
      );
      
    case 'lightbulb':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 18h6" />
          <path d="M10 22h4" />
          <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0018 8 6 6 0 006 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 008.91 14" />
          <path d="M12 2v1" />
        </svg>
      );
      
    case 'shield':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      );
      
    case 'users':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 00-3-3.87" />
          <path d="M16 3.13a4 4 0 010 7.75" />
        </svg>
      );
      
    // Add any other icons as needed
    
    default:
      // Default icon as fallback
      return (
        <svg xmlns="http://www.w3.org/2000/svg" className={combinedClasses} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8v8" />
          <path d="M8 12h8" />
        </svg>
      );
  }
};

export default ValueIcon;